import React from 'react';
import { AuthContext } from "../../AuthContext";
import "../register.css";
import * as FaIcons from 'react-icons/fa';
import { EditingServiceRow } from './EditingServiceRow';
import { NewServiceRow } from './NewServiceRow';
import { ServiceRow } from './ServiceRow';

const TableServices = (props) => {
    const authContext = React.useContext(AuthContext);
    const params = props.params;
    const paramsAddress = props.params.addresses;
    const [services, setServices] = React.useState(params?.services.map((a, i) => ({ ...a, id: i })) ?? []);
    const [editingServiceId, setEditingServiceId] = React.useState();
    const [isAdding, setIsAdding] = React.useState(false);
    const [enableCheckbox, setEnableCheckbox] = React.useState(false);
    const [responseMessage, setResponseMessage] = React.useState("");
    const [isModified, setIsModified] = React.useState(false);

    const handleChangeButton = (isButtonDisabled) => {
        props.isButtonDisabled(isButtonDisabled);
    }

    const handleChangeIsModified = (isModified) => {
        setIsModified(isModified);
    }

    const handleChangeMessage = (responseMessage) => {
        setResponseMessage(responseMessage);
    }

    const handleDeleteService = (serviceId) => {
        setServices(aa => aa.filter(a => a.id !== serviceId));
    }

    const handleEditService = (serviceId) => {
        setEditingServiceId(serviceId);
        setEnableCheckbox(true);
    }

    const handleDismissEdit = () => {
        setEditingServiceId(undefined);
        handleChangeButton(false);
        setEnableCheckbox(false);
        setResponseMessage(null);
    }

    const handleCancelRow = () => {
        setIsAdding(false);
        handleChangeButton(false);
        setResponseMessage(null);
    }

    const handleSaveService = (service) => {
        if (isModified === true) {
            const err = checkService(service);
            if (checkService(service) === "") {
                setServices(aa => {
                    let newServices = [...aa];
                    const serviceIndex = newServices.findIndex(a => a.id === service.id);
                    if (serviceIndex === -1) {
                        var id = Math.max.apply(Math, newServices.map(a => a.id));
                        newServices.push({ ...service, id: isFinite(id) ? id + 1 : 0 });
                    }
                    else
                        newServices[serviceIndex] = service;

                    return newServices
                });

                setEditingServiceId(undefined);
                handleChangeButton(false);
                setIsAdding(false);
                setResponseMessage(err);
                setIsModified(false);
            }

            setResponseMessage(err);
        }
        else {
            setEditingServiceId(undefined);
            handleChangeButton(false);
            setIsAdding(false);
        }
    }

    const checkService = (service) => {
        let array = [...services];
        let message = "";

        if (service.idServiceType === 1) {
            let c = paramsAddress.filter(x => x.idServiceType === 1).length;
            if (c === 0)
                message = "The channel inserted is not available in your list. Please check your list of channels.";
        }
        if (service.idServiceType === 3) {
            let c = paramsAddress.filter(x => x.idServiceType === 3).length;
            if (c === 0)
                message = "The channel inserted is not available in your list. Please check your list of channels.";
        }
        if (service.idServiceType === 10) {
            let c = paramsAddress.filter(x => x.idServiceType === 10).length;
            if (c === 0)
                message = "The channel inserted is not available in your list. Please check your list of channels.";
        }

        for (let i = 0; i < array.length; i++) {
            if (array[i].idServiceType === service.idServiceType && array[i].eventType === service.eventType &&
                array[i].alertLevel === service.alertLevel && array[i].region === service.region && array[i].language === service.language &&
                array[i].stopNight === service.stopNight && array[i].enabled === service.enabled)
                message = "The alert for this hazard has been already inserted. Please check.";

        }

        return message;
    }


    React.useEffect(() => {
        props.onChange(services);
        props.isButtonDisabled(isModified);
    }, [services, isModified]);

    return (
        <div>
            <table className="table generic_detail" id="services">
                <thead style={{ backgroundColor: "#ed7d31", color: "white" }}>
                    <tr>
                        <th className="cell_hidden" >Id</th>
                        <th className="cell_hidden">Id Services</th>
                        <th>Event Type</th>
                        <th>Channel</th>
                        <th>Level</th>
                        <th>Region</th>
                        <th>Language</th>
                        <th>StopNight</th>
                        <th>Enabled</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        services.map((service) => {
                            if (service.id === editingServiceId)
                                return <EditingServiceRow service={service} onRequestSaveService={handleSaveService} onRequestDismissEdit={handleDismissEdit} isButtonDisabled={handleChangeButton} responseMessage={handleChangeMessage} isModified={ handleChangeIsModified} />
                            return <ServiceRow service={service} onRequestDeleteService={handleDeleteService} onRequestEditService={handleEditService} />
                        })
                    }
                    {
                        services.length === 0 &&
                        <tr>
                            <td style={{ textAlign: "center" }}>No Events Types found.</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    }
                    {
                        isAdding &&
                        <NewServiceRow service={services} onRequestSaveService={handleSaveService} onRequestCancelRow={handleCancelRow} isButtonDisabled={handleChangeButton} responseMessage={handleChangeMessage} isModified={handleChangeIsModified}/>
                    }
                    {
                        !isAdding &&
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                                <button type='button' className="btn btn_table btn-primary" style={{ backgroundColor: "#ed7d31" }} onClick={() => { setIsAdding(true); }}><FaIcons.FaPlus style={{ height: '20px' }} /></button>
                            </td>
                        </tr>
                    }
                </tbody>
            </table >
            {responseMessage &&
                <div className="input-feedback col-12">{responseMessage}</div>
            }
        </div>
    )
}

export { TableServices };